import { ERequestType } from "../../Enum/ERequestType"
import { AdminUpdateSubscription } from "../../Objects/AdminDashboard/AdminUpdateSubscription"
import { AdminSubscriptionMonitoringDetails } from "../../Objects/AdminDashboard/AdminSubscriptionMonitoringDetails"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest, PutRequest } from "../../services/ApiClientService"

export const useGetAdminSubscriptionMonitoringDetails = () => {
  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetAdminSubscriptionMonitoringDetails = async (
    companyId: number,
    onSuccess: (data: AdminSubscriptionMonitoringDetails) => void,
  ) => {
    enableLoad()

    try {
      const response = await GetRequest<AdminSubscriptionMonitoringDetails>(
        API_ROUTES.ADMIN_DASHBOARD.GET_SUBSCRIPTION_MONITORING_DETAILS(companyId),
        ERequestType.Admin,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess(new AdminSubscriptionMonitoringDetails(response.data ?? {}))
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : "Erro ao carregar os detalhes da assinatura."

      setError("Monitoramento de assinaturas", message)
    } finally {
      disableLoad()
    }
  }

  const handleToggleCompanyTestOrDemo = async (
    companyId: number,
    isTestOrDemoCompany: boolean,
    onSuccess: () => void,
  ) => {
    enableLoad()

    try {
      const response = await PutRequest(
        API_ROUTES.ADMIN_DASHBOARD.TOGGLE_COMPANY_TEST_OR_DEMO(companyId),
        { isTestOrDemoCompany },
        ERequestType.Admin,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess()
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : "Erro ao atualizar empresa teste/demo."

      setError("Monitoramento de assinaturas", message)
    } finally {
      disableLoad()
    }
  }

  const handleUpdateSubscription = async (
    subscriptionId: number,
    request: AdminUpdateSubscription,
    onSuccess: () => void,
  ) => {
    enableLoad()

    try {
      const response = await PutRequest(
        API_ROUTES.ADMIN_DASHBOARD.UPDATE_SUBSCRIPTION(subscriptionId),
        request,
        ERequestType.Admin,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess()
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : "Erro ao atualizar assinatura."

      setError("Monitoramento de assinaturas", message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetAdminSubscriptionMonitoringDetails,
    handleToggleCompanyTestOrDemo,
    handleUpdateSubscription,
  }
}
